import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"
import { DEFAULT_BRANCH_ID } from "../../constant"

const ENDPOINT = "/contractor-payout-payments"

export interface ContractorPayoutPayment {
  _id: string
  contractor: {
    _id: string
    name?: string
    contractorId?: string
    commissionPercentage?: number
  }
  branch: string
  paymentDate: string
  amount: number
  note?: string
  status?: "paid" | "cancelled"
  createdBy?: {
    _id: string
    firstName?: string
    lastName?: string
  } | null
  createdAt?: string
  updatedAt?: string
}

export interface ContractorPayoutSummary {
  totalCollected: number
  amountToPay: number
  alreadyPaid: number
  balance: number
  studentCount: number
  commissionPercent: number
}

export interface ListPaymentsParams {
  contractorId?: string
  startDate?: string
  endDate?: string
  search?: string
  page?: number
  limit?: number
}

export interface ListPaymentsResponse {
  data: ContractorPayoutPayment[]
  pagination: {
    page: number
    limit: number
    total: number
    pages: number
  }
}

const branchParam = () =>
  DEFAULT_BRANCH_ID ? { branchId: DEFAULT_BRANCH_ID } : {}

export const listContractorPayoutPayments = async (
  params: ListPaymentsParams = {}
): Promise<ListPaymentsResponse> => {
  const { contractorId, startDate, endDate, search, page = 1, limit = 20 } = params
  const response = await apiClient({
    url: appendQueryParams(ENDPOINT, {
      ...branchParam(),
      ...(contractorId && { contractorId }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
      ...(search && { search }),
      page,
      limit,
    }),
    method: "GET",
  })
  return response.data
}

export const getContractorPayoutPaymentById = async (
  paymentId: string
): Promise<ContractorPayoutPayment> => {
  const response = await apiClient({
    url: appendQueryParams(`${ENDPOINT}/${paymentId}`, branchParam()),
    method: "GET",
  })
  return response.data
}

export const createContractorPayoutPayment = async (payload: {
  contractorId: string
  paymentDate: string
  amount: number
  note?: string
}): Promise<ContractorPayoutPayment> => {
  const response = await apiClient({
    url: ENDPOINT,
    method: "POST",
    data: {
      ...payload,
      ...(DEFAULT_BRANCH_ID && { branchId: DEFAULT_BRANCH_ID }),
    },
  })
  return response.data
}

export const cancelContractorPayoutPayment = async (
  paymentId: string
): Promise<ContractorPayoutPayment> => {
  const response = await apiClient({
    url: `${ENDPOINT}/${paymentId}/cancel`,
    method: "PATCH",
  })
  return response.data
}

export const getContractorPayoutSummary = async (params: {
  contractorId: string
  startDate: string
  endDate: string
}): Promise<ContractorPayoutSummary> => {
  const response = await apiClient({
    url: appendQueryParams(`${ENDPOINT}/summary`, {
      contractorId: params.contractorId,
      startDate: params.startDate,
      endDate: params.endDate,
    }),
    method: "GET",
  })
  return response.data
}

export const getAggregatedPayoutSummary = async (params: {
  startDate: string
  endDate: string
}): Promise<ContractorPayoutSummary> => {
  const response = await apiClient({
    url: appendQueryParams(`${ENDPOINT}/aggregate-summary`, {
      startDate: params.startDate,
      endDate: params.endDate,
    }),
    method: "GET",
  })
  return response.data
}
